import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { Expense, ExpenseDTO } from '../../models/expense.interface';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RequestService } from '../request/request';
import { Pagination } from '../../models/pagination.interface';
import { QueryGet } from '../../types/query-types';
import { OptionSelect } from '../../../shared/components/search-select/search-select';

@Injectable({
  providedIn: 'root',
})
export class ExpensesService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'expenses/';
  url = environment.service_1 + 'all-expenses/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedexpense = new BehaviorSubject<Expense | null>(null);
  selectedexpense$ = this.selectedexpense.asObservable();

  private expenses = new BehaviorSubject<Expense[]>([]);
  expenses$ = this.expenses.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setExpense(expense: Expense) {
    this.selectedexpense.next(expense);
  }

  setExpenses(expenses: Expense[]) {
    this.expenses.next(expenses);
  }

  removeExpenseSelected() {
    this.selectedexpense.next(null);
  }

  createExpense(expense: ExpenseDTO) {
    return this.http.post<Expense>(this.urlPath, expense).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  UpdateExpense(id: number, expense: ExpenseDTO & { id: number }) {
    return this.http.put<Expense>(this.urlPath + id + '/', expense).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getExpenses(query: QueryGet): Observable<Pagination<Expense[]>> {
    return this.requestService.get<Expense[]>(this.urlPath, query);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

  getExpense(): Observable<Expense[]> {
    return this.http.get<Expense[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  getOptionExpense(line: Expense[]): OptionSelect[] {
    return line.map((item: Expense) => {
      return {
        value: item.id ?? '',
        label: item.total.toString(),
      };
    });
  }
}
